module.exports = __webpack_public_path__ + "img/1_2-commerciale-museo-1.b371971a.png";